import React, { useCallback } from 'react';
import { PaymentApiResponse } from 'src/types/payment';
import {
  CallbackResult,
  RedirectBasedPayment,
} from '../common/GenericPayment/RedirectBasedPayment';

interface XpressBillPayFormProps {
  loading: boolean;
  onPay: () => Promise<PaymentApiResponse | void>;
  permitIdentifier: string;
  totalDue: number;
  error?: string;
}

export const XpressBillPayForm = ({
  loading,
  onPay,
  permitIdentifier,
  totalDue,
  error,
}: XpressBillPayFormProps) => {
  const handleClickCallback = useCallback(async (): Promise<CallbackResult> => {
    const response = await onPay();

    if (!response || !('url' in response)) {
      return { url: '' };
    }

    const sURLParams = new URLSearchParams();

    // This is from the Single Permit view
    sURLParams.set('id', permitIdentifier);

    const windowUrl = new URL(`${response.url}?${sURLParams}`);

    window.open(windowUrl, '_blank', 'toolbar=0,location=0,menubar=0');

    return { url: windowUrl };
  }, [permitIdentifier, onPay]);

  return (
    <RedirectBasedPayment
      dataTestId="xpress-bill-pay-form-component"
      error={error}
      loading={loading}
      onClickCallback={handleClickCallback}
      totalDue={totalDue}
    >
      The button below will take you to the Xpress Bill Pay system to make your
      payment. A service charge will be added if paying with a credit card.
    </RedirectBasedPayment>
  );
};
